<div
  class="modal fade"
  id="empresaModal"
  tabindex="-1"
  aria-labelledby="empresaModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="empresaModalLabel">
          <ng-container *ngIf="!modoEliminar">
            {{ modoEditar ? "Editar Empresa" : "Nueva Empresa" }}
          </ng-container>
          <ng-container *ngIf="modoEliminar"> Eliminar Empresa </ng-container>
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="!modoEliminar">
          <form (ngSubmit)="guardarEmpresa()">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="cuit" class="form-label">CUIT</label>
                <input
                  type="number"
                  class="form-control"
                  id="cuit"
                  [(ngModel)]="empresa.cuit"
                  name="cuit"
                  required
                  [disabled]="modoEditar"
                  [ngClass]="{ 'is-invalid': errores['cuit'] }"
                />
                <div *ngIf="errores['cuit']" class="invalid-feedback">
                  {{ errores["cuit"] }}
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <label for="razonSocial" class="form-label">Razón Social</label>
                <input
                  type="text"
                  class="form-control"
                  id="razonSocial"
                  [(ngModel)]="empresa.razonSocial"
                  name="razonSocial"
                  required
                  [ngClass]="{ 'is-invalid': errores['razonSocial'] }"
                />
                <div *ngIf="errores['razonSocial']" class="invalid-feedback">
                  {{ errores["razonSocial"] }}
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between mt-3">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="cerrarModalEmpresa()"
              >
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">
                {{ modoEditar ? "Actualizar" : "Guardar" }} Empresa
              </button>
            </div>
          </form>
        </ng-container>

        <ng-container *ngIf="modoEliminar">
          <div class="alert alert-danger">
            <i class="fas fa-exclamation-triangle me-2"></i>
            ¿Está seguro que desea eliminar la empresa
            <strong>{{ empresa.razonSocial }}</strong> con CUIT
            <strong>{{ empresa.cuit }}</strong
            >?
            <br />
            Esta acción no se puede deshacer.
          </div>
          <div class="d-flex justify-content-between mt-3">
            <button
              type="button"
              class="btn btn-secondary"
              (click)="cerrarModalEmpresa()"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="eliminarEmpresa()"
            >
              Eliminar Empresa
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
